import { getUnityBridgeCommands } from "../../lib/unityCommandBridge";

const EDGE_INSET = 20;
const BUTTON_SIZE = 44;

const buttonStyle = {
  width: BUTTON_SIZE,
  height: BUTTON_SIZE,
  display: "grid",
  placeItems: "center",
  padding: 0,
  borderRadius: "50%",
  border: "1px solid rgba(255,255,255,0.35)",
  background: "rgba(255,255,255,0.18)",
  backdropFilter: "blur(8px)",
  WebkitBackdropFilter: "blur(8px)",
  color: "#475569",
  cursor: "pointer",
  pointerEvents: "auto",
  transition: "background 0.18s ease",
};

function Chevron({ direction }) {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <polyline
        points={direction === "left" ? "15 5 8 12 15 19" : "9 5 16 12 9 19"}
        stroke="#fff"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ArrowButton({ direction, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={direction === "left" ? "Previous hotspot" : "Next hotspot"}
      style={buttonStyle}
    >
      <Chevron direction={direction} />
    </button>
  );
}

export default function HotspotNavArrows({ topOffset = 0, zIndex = 10000, hidden = false }) {
  const navigate = (direction) => {
    getUnityBridgeCommands()?.navigateHotspot?.(direction);
  };

  if (hidden) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: topOffset,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: `0 ${EDGE_INSET}px`,
        pointerEvents: "none",
        zIndex,
      }}
    >
      <ArrowButton direction="left" onClick={() => navigate("left")} />
      <ArrowButton direction="right" onClick={() => navigate("right")} />
    </div>
  );
}
